import React, {Fragment} from 'react';

export default {
    PROJECTS_PROJECT_Jinxed: {
        LOGLINE: <Fragment>
            <p>
                Die beiden Kleinkriminellen Chris Brokowski und William Dyno sind zwei echte Pechvögel.<br />
                Ihr Traum vom Geld wird leider durch große Probleme zerstört.
            </p>
            <p>
                Jetzt heißt es für sie:<br />
                Lebend aus der Sache herauskommen...
            </p>
        </Fragment>,
        TRIVIA: [
            'Von Jinxed gibt es sowohl eine deutsche als auch eine englische Version'
        ]
    },
    PROJECTS_PROJECT_Eine_INM_Weihnachtsgeschichte: {
        LOGLINE: <Fragment>
            <p>
                Fröhliche Weihnachten 2015!
            </p>
        </Fragment>
    },
    PROJECTS_PROJECT_The_Dosshouse_3: {
        LOGLINE: <Fragment>
            <p>
                Seht was es mit dem Dosshouse Mörder auf sich hat...<br />
                Seht wie alles begann!
            </p>
        </Fragment>,
        TRIVIA: [
            'Der klassische Vorspann wird beibehalten',
            'Um 2:35 im Film, läuft der Film "Ice Cold Killers" im Fernsehen'
        ]
    },
    PROJECTS_PROJECT_Christmas_carols_and_stuff: {
        LOGLINE: <Fragment>
            <p>
                Fröhliche Weihnachten 2012!
            </p>
        </Fragment>,
        TRIVIA: [
            'Im Polizeicomputer findet man neben Dean Wood auch den Dosshouse Killer (The Dosshouse), Thomas Crone und Francis Payne (100.000 To Live Longer), sowie Santa Claus',
            'Im Browser des Polizeicomputers ist die Seite von R* Games, das WikINM, sowie eine Pornoseite abgespeichert'
        ]
    },
    PROJECTS_PROJECT_The_Chase: {
        LOGLINE: <Fragment>
            <p>
                The Chase... Das Video zu den gekürzten Fassungen von "Dark Chase" und "Chased Till Dawn".
            </p>
            <p>
                Es geht um eine Person die einen Anruf erhält.
                Dieser geht von einer Telefonzelle aus, die gegenüber vom Haus der Person liegt.
                Da sich die Person ausgesperrt hat, nachdem sie vor dem Haus nachsieht, fährt sie davon.
                Die Jagt beginnt.
            </p>
            <p>
                Das Ganze wird mit den beiden Musikstücken "Dark Chase" und später "Chased Till Dawn" untermalt.
            </p>
        </Fragment>,
        TRIVIA: [
            'The Chase ist der erste Film, der nur eigens produzierte Musik enthält',
            'Der Film besteht an sich nur aus "Dark Chase" und "Chased Till Dawn"',
            'Es wird nicht "Gesprochen"',
            'Auf dem Kennzeichen der Person steht "NOTDONE", auf dem des Irren steht "K1l73R"'
        ]
    },
    PROJECTS_PROJECT_Ice_Cold_Killers: {
        LOGLINE: <Fragment>
            <p>
                Nachdem die Polizei von Los Santos 10 Tonnen Kokain bei einer Razzia am Hafen Los Santos' beschlagnahmt hat,
                meldet sich der korrupte Cop Shaun Reynolds bei den Anführern der beiden größten Drogenringen der Stadt,
                Jerome 'Big Jay' Reever und Richard 'Richie' Kellard.
            </p>
            <p>
                Er bietet ihnen ein Geschäft an, das sie lieber hätten ablehnen sollen...
            </p>
        </Fragment>,
        TRIVIA: [
            'Die Grundidee zum Film kam bereits im April 2009 (noch vor Restless Survivors), doch wurde sie nie verwirklicht, bis ein Gewinnspiel gestartet wurde. Als Preise wurden Rollen für den Film "Ice Cold Killers" vergeben, der dann endlich produziert werden sollte',
            'Der Film wurde am 31.12.2011 veröffentlicht, musste aber wegen dem Anschlagen des YouTube Content ID Filters wieder entfernt werden, was die Veröffentlichung um über eine Woche verzögerte. So entstanden insgesamt 4 Versionen des Films, die sich lediglich durch ein bis zwei Musiktitel unterscheiden'
        ]
    },
    PROJECTS_PROJECT_28_Hours_Before_Christmas: {
        LOGLINE: <Fragment>
            <p>
                Albert Finnegeons ultimative Weihnachtsgeschichte...
            </p>
        </Fragment>,
        TRIVIA: [
            'Der Film wurde fast komplett improvisiert'
        ]
    },
    PROJECTS_PROJECT_Zed_2_Recommended_Gateway: {
        LOGLINE: <Fragment>
            <p>
                Tony Zachery ist mit seinem Chauffeur in seiner Limousine unterwegs in Las Venturas, als Pete - der Chauffeur - plötzlich verschwindet. Tony bemerkt, dass die Stadt menschenleer ist...
            </p>
        </Fragment>,
        TRIVIA: [
            'Der Film entstand - wie sein Vorgänger - komplett an einem Wochenende (Story, Szenen, Schnitt und Nachbearbeitung)'
        ]
    },
    PROJECTS_PROJECT_100000_To_Live_Longer: {
        LOGLINE: <Fragment>
            <p>
                Thomas Crone...<br />
                Hat Schulden...<br />
                Bei gefährlichen Typen...<br />
                Er braucht Geld...<br />
                Wird er ein Mörder?<br />
                Das entscheidest du!
            </p>
        </Fragment>,
        TRIVIA: [
            '100.000 To Live Longer ist ein interaktiver Film',
            'Der Film hat 16 alternative Enden',
            'Der Film hat eine Gesamtlänge von 4 Stunden, 5 Minuten und 2 Sekunden',
            'Die Arbeiten zum Film begannen am 02.04.2011',
            'Im Film wurden viele nebensächliche Details beachtet, z.B. wurden die Mündungen von Waffen - die eigentlich nicht existieren - extra als schwarzer Kreis in den Film eingefügt, außerdem gibt es Stellen, bei denen man von außen durch Türen/Fenster in Häuser schauen kann, was im Spiel eigentlich auch nicht möglich ist',
            'Es gibt im Film Sätze, die man erst versteht, wenn man den Film mehrmals sieht und sich an manchen Stellen anders entscheidet',
            'Der technische Aufwand war bei diesem Film sehr hoch'
        ]
    },
    PROJECTS_PROJECT_Rolling_Dope_2: {
        LOGLINE: <Fragment>
            <p>
                Dean Simmons und Brian O'Neil werden gegen ihren Willen festgehalten.
                Können sie fliehen und die Polizei benachrichtigen?
            </p>
        </Fragment>,
        TRIVIA: [
            'Der Film setzt genau an dem offenen Ende von "Rolling Dope" an'
        ]
    },
    PROJECTS_PROJECT_What_The_Government_Denies: {
        LOGLINE: <Fragment>
            <p>
                Die Regierung... Sie weiß es... Es sind die Einzigen, die es wissen können...
            </p>
        </Fragment>,
        TRIVIA: [
            'Der Film entstand nur, weil wesone UFO Montagen veröffentlichen wollte. Aus den einzelnen Montagen ist dann ein ganzer Film entstanden',
            'In Jay\'s Diner steht auf der Kaffeetasse von Dexter "INM entertainment"',
            'Um 6:05 im Film, läuft der Film "The Dosshouse" im Fernsehen',
        ]
    },
    PROJECTS_PROJECT_Eine_Splatter_Weihnachtsgeschichte: {
        LOGLINE: <Fragment>
            <p>
                Tom LeeRoys ultimative Weihnachtsgeschichte...
            </p>
        </Fragment>,
        TRIVIA: [
            'Der Film ist eine Weihnachts-Splatter-Horror-Komödie'
        ]
    },
    PROJECTS_PROJECT_Zed_Last_Time_On_Earth: {
        LOGLINE: <Fragment>
            <p>
                Auf dem weg zu einem wichtigen Geschäftsgespräch stürzt der Privatjet von Anthony Zagson ab. Anthony überlebt den absturz... Er findet sich an einem unbekannten Ort wieder.
            </p>
        </Fragment>,
        TRIVIA: [
            'Der Film entstand komplett an einem Wochenende (Story, Szenen, Schnitt und Nachbearbeitung)'
        ]
    },
    PROJECTS_PROJECT_The_Dosshouse_2: {
        LOGLINE: <Fragment>
            <p>
                Bob und Fred sind mit dem Taxi auf dem Weg zu ihrem Freund Dave.
                Sie haben Daves Junggesellenabschied geplant und wollen ihn mit einem Besuch in einem Stripclub in Las Venturas überraschen.
                Sie kommen an eine Bar, die zum Verkauf steht.
            </p>
            <p>
                Die drei Freunde beschließen, die Bar zu kaufen und damit beginnt ihr Albtraum...
            </p>
        </Fragment>,
        TRIVIA: [
            'Der Vorspann ähnelt stark dem Vorspann von "The Dosshouse"',
            <Fragment>Die Telefonnummer 937663 ergibt sich aus "wesone" im <a href="https://de.wikipedia.org/wiki/Buchstabenwahl" target="_blank" rel="noopener noreferrer">Vanity-System</a></Fragment>
        ]
    },
    PROJECTS_PROJECT_Aments_of_Bayside: {
        LOGLINE: <Fragment>
            <p>
                Rick und Susan DeLorean machen Urlaub, um sich von ihrem stressigen Alltag zu erholen.
                Sie haben dafür eine Ferienwohnung für eine Woche gemietet, die sie im Internet gefunden haben.
            </p>
            <p>
                Allerdings wird ihr Urlaub nicht so, wie sie ihn erwartet hatten...
            </p>
        </Fragment>,
        TRIVIA: [
            'Der Film lag lange zeit "auf Eis", bis er am 26. Oktober 2012 veröffentlicht wurde',
            'Das Ende des Films wurde im letzten Moment improvisiert'
        ]
    },
    PROJECTS_PROJECT_Bad_Moon_Rising: {
        LOGLINE: <Fragment>
            <p>
                Seit Wochen gab es in Los Santos keinen Regentropfen mehr.
                Stattdessen herrscht große Hitze, die jegliche Lust an Aktivitäten verwelken lässt.
            </p>
            <p>
                Dean Wood (Deadwood) und John Castle (wesone) sind zwei gute Freunde, denen die Hitze ebenfalls auf den Magen schlägt...
                Doch dann beginnt "Tag 1" an dem die Dürreperiode ein Ende hat.
            </p>
        </Fragment>,
        TRIVIA: [
            'Es war ursprünglich ein komplett anderes Ende gedacht, in dem sich John und Dean zu anderen Überlebenden zum "Mount Chiliad" durchschlagen',
            'Der Name "Dean Wood" ist abgeleitet von Deadwood',
            'Um 6:15 im Film, pinkelt Dean an einen Streifenwagen, was eine Art "Markenzeichen" von INM widerspiegelt'
        ]
    },
    PROJECTS_PROJECT_The_Parody: {
        LOGLINE: <Fragment>
            <p>
                Dies ist eine kleine Parodie, die aber nicht allzu ernst genommen werden sollte!
            </p>
        </Fragment>,
        TRIVIA: [
            '"The Parody" ist eine Parodie auf einen YouTuber, der diverse Ideen aus der "INM Comedy Show" (ohne Erlaubnis) in seinen Videos benutzte. INM war zwar nicht wütend, aber sie wollten dies auch nicht unbeantwortet lassen. Sie fragten, ob sie eine kleine Parodie drehen dürften... mit Erfolg',
            'Erst war geplant, diverse Parodien des YouTubers in der nächsten "INM Comedy Show" zu veröffentlichen, doch es entstanden dann zu viele Ideen, sodass kein Platz mehr für andere Sketche gewesen wäre. Also wollte INM ein "INM Comedy Show Special" machen, doch letztendlich entschieden sie sich für einen komplett anderen Film... "The Parody"'
        ]
    },
    PROJECTS_PROJECT_Unlocked_and_Loaded: {
        LOGLINE: <Fragment>
            <p>
                Es ist Freitagmorgen und es läuft die Aftershow-Party...
            </p>
            <p>
                Was INM noch nicht weiß, es wird ein langer Freitag...
            </p>
        </Fragment>,
        TRIVIA: [
            'Die Idee zu diesem Film stammt von wesone',
            'SergejVodkakov spielt nicht in diesem Film mit',
            'Jacqui war zu diesem Zeitpunkt noch nicht im Team'
        ]
    },
    PROJECTS_PROJECT_The_Dosshouse: {
        LOGLINE: <Fragment>
            <p>
                Wesley Walker und Walter Kingsley sind alte Freunde.
                Sie kannten sich schon vor dem College.
                Nach langer Zeit beschließen sie, sich mal wieder zu Treffen undzwar in einer kleinen Bar.
                Es wird immer später und die Bar ist schon leer.
                Mitten in der Nacht wollen sie dann nach Hause...
            </p>
            <p>
                Doch da fangen die Probleme an...
            </p>
        </Fragment>,
        TRIVIA: [
            'The Dosshouse greift das Splatter-Klischee auf, ist jedoch an keinen Film angelehnt und bezieht sich auch auf keinen realen Film'
        ]
    },
    PROJECTS_PROJECT_Rolling_Dope: {
        LOGLINE: <Fragment>
            <p>
                Dean Simmons und Brian O'Neil sind 2 schlecht bezahlte Trucker, die für den Bierproduzenten Fleischberg arbeiten.
                Als sie an ein nicht ganz legales Unternehmen liefern, nimmt das Unheil seinen Lauf.
            </p>
        </Fragment>,
        TRIVIA: [
            'Rolling Dope war der erste Film von INM in Full HD und Widescreen',
            'Die direkte Fortsetzung "Rolling Dope 2" erschien erst sehr viel später',
            'In Rolling Dope spielt zum ersten Mal SergejVodkakov mit, jedoch nicht mit seinem Skin. Er heißt lediglich so und spielt den Inhaber von Fleischberg',
            'Seit Rolling Dope ist es eine Art Markenzeichen, dass in den Filmen von INM gepinkelt wird'
        ]
    },
    PROJECTS_PROJECT_Die_INM_Comedy_Show: {
        LOGLINE: <Fragment>
            <p>
                Die INM Comedy Show war als Special gedacht, um einen Meilenstein bei der Anzahl der Abonnenten zu feiern.
                Die Show kam sehr gut an, weshalb es später immer mal wieder einen neuen Part der Comedy Show gab.
            </p>
            <p>
                In jedem Part führen wesone und killerman an einem neuen Schauplatz durch die Show, die dann aus unterschiedlichsten kleinen Comedy-Szenen besteht.
            </p>

            <p>
                <h5>Part 1 - 19.02.2010</h5>
                war das 200 Abonnenten Special und der Beginn der Comedy Show.
                Schauplatz ist ein Baseballplatz in San Fierro.
            </p>
            <p>
                <h5>Part 2 - 26.06.2010</h5>
                war das 300 Abonnenten Special.
                Dieser Part spielt an dem Bahnhof in San Fierro.
            </p>
            <p>
                <h5>Part 3 - 19.02.2011</h5>
                kam nicht pünktlich bei 600 Abonnenten, weshalb er als 650 Abonnenten Special diente.
                Der Schauplatz ist auf der "Gant Bridge", die San Fierro und Tierra Robada voneinander trennt.
            </p>
            <p>
                <h5>Part 4 - 16.02.2013</h5>
                feierte die 1000 Abonnenten und ist bisher der letzte Part.
                Er spielt in wesones Infernus, mit denen die "Erzähler" von Los Santos, über San Fierro, nach Las Venturas fahren.
            </p>
        </Fragment>,
        TRIVIA: [
            'Die INM Comedy Show wurde von killerman und wesone ins Leben gerufen. Sie schreiben die Sketche und Jokes'
        ]
    },
    PROJECTS_PROJECT_Desert_Homicide: {
        LOGLINE: <Fragment>
            <p>
                John Derek und Thomas Sullivan sind 2 Cops aus Las Venturas.
                Sie sind schon lange Partner und fahren oft Streife, doch was sie heute erleben ist alles andere als ein normaler Arbeitstag.
            </p>
        </Fragment>,
        TRIVIA: [
            'Bis zum Schluss bleibt es offen, ob Thomas noch lebt oder tod ist',
            'Eine Fortsetzung ist nicht geplant'
        ]
    },
    PROJECTS_PROJECT_WTC_9_11_2001: {
        // LOGLINE: ,
        TRIVIA: [
            'Die Idee zum Film kam allein von killerman'
        ]
    },
    PROJECTS_PROJECT_Restless_Survivors: {
        LOGLINE: <Fragment>
            <p>
                Roman Colusso und Nick McCarthy leben in einer Welt, die nichts für schwache Nerven ist.
                Ihr Ziel ist es zu Überleben!
            </p>
            <p>
                <h5>Teil 2 - 20.08.2009</h5>
                Um die rettende Stadt Sun Wes City erreichen zu können, müssen Roman und Nick einen kleinen Umweg machen.
            </p>
            <p>
                <h5>Teil 3 - 29.12.2009</h5>
                Seht wie alles begann. Team Sierra wird gerufen um die Epidemie aufzuhalten.
            </p>
            <p>
                <h5>Teil 4 - 28.07.2011</h5>
                Nach einem Jahr, 6 Monaten, 29 Tagen, 22 Stunden und 2 Minuten wurde "Restless Survivors" fortgesetzt und beendet...
                Ein historischer Tag.
            </p>
        </Fragment>,
        TRIVIA: [
            'Restless Survivors umfasst eine Reihe von 4 Filmen',
            'Nachdem Restless Survivors mehrfach raubkopiert wurde, wurde in Restless Survivors III von wesone erstmals ein ©-Zeichen (Copyright) eingefügt',
            'Erst nach einem Jahr, 6 Monaten, 29 Tagen, 22 Stunden und 2 Minuten, nachdem Restless Survivors III erschien, wurde Restless Survivors IV veröffentlicht',
            'Das Ende von Restless Survivors IV war ursprünglich gleich nach der Explosion der Bombe, doch das wurde nocheinmal geändert und nun rächt sich Roman nach der Explosion an Dr. Dublin'
        ]
    },
}
